import React, { useEffect, useRef } from 'react';
import { IoMdClose } from "react-icons/io";
import Button from './Button';

const Popup = ({ labels, blocks, langId, colors, popup, setPopup }) => {

  const scrollableDivRef = useRef(null);

  const handleKeyDown = (event) => {
    switch (event.key) {
      case 'Backspace':
        // Close the event when the Escape key is pressed
        setPopup(false);
        break;
      case 'Escape':
        // Close the event when the Escape key is pressed
        setPopup(false);
        break;

      case 'ArrowDown':

        scrollableDivRef.current.focus();
        break;
      case 'ArrowLeft':
        setPopup(false);
        break;
      case 'ArrowRight':
        // Handle arrow keys if needed
        setPopup(false);
        break;
      default:
        break;
    }
  };



  // Add event listener for keydown events
  useEffect(() => {

    window.addEventListener('keydown', handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // Empty dependency array ensures this effect runs once on mount

  return <div className="fixed left-0 right-0 top-0 bottom-0 w-full h-full bg-white z-20 ">
    <div className="cursor-pointer fixed right-0 top-0 p-5 flex space-x-5 items-center" onClick={() => setPopup(null)}>
      <Button>
        <div className="flex space-x-2 items-center">
          <div>{labels?.["close"]?.lang?.[langId]?.name}</div>

          <IoMdClose />
        </div>

      </Button>

    </div>

    <div className="h-full overflow-y-scroll p-5  " ref={scrollableDivRef} >




      <div className="flex justify-center"><h2 className="text-xl font-bold leading-none">{popup?.lang[langId]?.title}</h2></div>

      <div className="flex justify-center mt-2">


        <div key={"circle"} style={{ backgroundColor: colors[popup.index] }} className="rounded-full bg-primary w-16 h-16 flex items-center justify-center">{popup.score} / 10 </div>
      </div>

      <div className="flex justify-center mt-5">

        <div className="info" dangerouslySetInnerHTML={{ __html: popup?.lang[langId]?.info }}></div>
      </div>
      <div className="flex justify-center mt-5">
        <div className="info" dangerouslySetInnerHTML={{ __html: popup?.lang[langId]?.blocks.split('opacity-0').join('opacity-100').split('-mt-10').join('mt-0').split('mx-auto container p-5 shadow-lg bg-white').join('') }}></div>
      </div>
    </div>

  </div>
}

export default Popup;
